import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { Typography } from '@material-ui/core';
import Box from '@mui/material/Box';
import InnerHTML from 'dangerously-set-html-content';
import BackgroundTheme from '../../../Common/P2P/Header/BackgroundTheme';
import RoundButton from '../../../Common/RoundButton';
import { useDispatch, useSelector } from 'react-redux';
import { getPaymentGatewayReq, getResetValue } from './investFundAction';
import ErrorMessage from '../../../Common/ErrorMessage';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import safetyImg from '../../../utils/assests/safety.svg';
import payuImg from '../../../utils/assests/payu.png';
import bankImg from '../../../utils/assests/bank.svg';
import { logFirebaseEvent } from '../firebase';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import {
  P2P_NEFT_PAYMENT_MODE_BTN,
  P2P_PAYMENT_MODE_VIEW,
  P2P_PG_PAYMENT_MODE_BTN,
} from '../firebase/constant';

const InvestFund = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [neftValue, setNeftValue] = useState('');

  const { kycBackedData, kycBackedError } = useSelector(
    (state: any) => state.personalInfo
  );

  const { gatewayData, errorGateway, addMoneyAmount } = useSelector(
    (state: any) => state.investFund
  );

  useEffect(() => {
    logFirebaseEvent(P2P_PAYMENT_MODE_VIEW);
    document.title = 'stashearn - invest-fund';
  }, []);

  useEffect(() => {
    if (kycBackedData || kycBackedError) {
      if (kycBackedData?.status && kycBackedData?.result) {
        window.open(kycBackedData?.result?.url);
      }
    }
  }, [kycBackedData, kycBackedError]);

  const handleRadioChange = (event: any) => {
    if (addMoneyAmount) {
      if (event === 'payu') {
        logFirebaseEvent(P2P_PG_PAYMENT_MODE_BTN);
        setNeftValue('payu');
        dispatch(getPaymentGatewayReq());
      }
      if (event.target.value === 'neft') {
        logFirebaseEvent(P2P_NEFT_PAYMENT_MODE_BTN);
        setNeftValue('neft');
        dispatch(getResetValue());
        history.push('/p2p/bank-detail');
      }
    } else {
      setNeftValue('showError');
      setTimeout(() => {
        history.push('/p2p/Addmoney');
      }, 3000);
    }
  };

  const goBackToAddMoney = () => {
    dispatch(getResetValue());
    history.push({
      pathname: '/p2p/Addmoney',
    });
  };

  return (
    <>
      {gatewayData === null || gatewayData?.error || errorGateway?.error ? (
        <BackgroundTheme>
          <Card className='redBorder'>
            <CardContent>
              <Box className='cardHeadingNew'>
                <Typography variant='h1'> Invest Funds</Typography>
                <Typography variant='h2'> Select payment method</Typography>
              </Box>

              <Box className='paymentOptionCardBox'>
                <Card
                  elevation={0}
                  className='paymentOptionCard'
                  onClick={() => handleRadioChange('payu')}
                >
                  <img src={payuImg} alt='pending status' width='48' />
                </Card>
              </Box>
              {/* <Box className='neft-cards-styles'>
            <FormControl fullWidth>
              <RadioGroup
                aria-labelledby='demo-radio-buttons-group-label'
                defaultValue={neftValue}
                name='radio-buttons-group'
                onChange={handleRadioChange}
                className='neftRadios'
              >
                <div>
                  <FormControlLabel value='payu' control={<Radio />} label='' />
                  <img src={payuImg} alt='pending status' width='48' />
                </div>
                <div>
                  <FormControlLabel value='neft' control={<Radio />} label='' />
                  <img src={bankImg} alt='pending status' width='20' />
                  <span className='MuiTypography-root'>NEFT/IMPS/RTGS</span>
                </div>
              </RadioGroup>
            </FormControl>
          </Box> */}
              {errorGateway && <ErrorMessage text={errorGateway} />}
              {neftValue === 'showError' && !addMoneyAmount && (
                <ErrorMessage text='Amount is not valid' />
              )}
              <div className='secureSafe cardBottomText '>
                <Typography>100% safe and secure</Typography>
                <Typography>
                  LiquiLoans is the RBI approved <br /> P2P NBFC that we use to
                  facilitate <br />
                  your investment.
                </Typography>
                <RoundButton
                  onClick={() => handleRadioChange('payu')}
                  title='Proceed'
                />
                <div onClick ={goBackToAddMoney} className='text-center refer-styles'>
                <u>Edit investment</u>
                </div>
              </div>
            </CardContent>
          </Card>
        </BackgroundTheme>
      ) : (
        <BackgroundTheme>
          {gatewayData && gatewayData?.results?.status === false ? (
            <BackgroundTheme>
              <Box
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  top: '50%',
                  color: '#a9023f',
                }}
              >
                <Typography align='center' variant='h6'>
                  {gatewayData?.results?.message}
                </Typography>
                <div className='bottomBtn'>
                  <RoundButton onClick={goBackToAddMoney} title='return' />
                </div>
              </Box>
            </BackgroundTheme>
          ) : (
            <InnerHTML html={gatewayData} />
          )}
        </BackgroundTheme>
      )}
    </>
  );
};

export default InvestFund;
